import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ClientsSessionService {
  private client: any = {};
  private permissions: string[] = [];

  constructor() {}

  init(): void {
    this.client = JSON.parse(sessionStorage.getItem('currentUser') || '{}');
    this.permissions = this.client['permissions'];
  }

  getClient() {
    return this.client;
  }

  getPermissions(): string[] {
    return this.permissions;
  }

  getUid(): string {
    return this.client['uid'] || '';
  }

  getUcode(): string {
    return this.client['ucode'] || '';
  }

  getCpid(): string {
    return this.client['cpid'] || '';
  }
}
